import { FunctionComponent } from 'react';

import { useProperty } from '~/client/hooks/storeHooks';
import { getPropertyBreadcrumbs } from '~/client/utils/navigation';
import { PcfraPerson, Person } from '~/common/types/people';

import { PageHeader } from '../PageHeader';

interface Props {
  person: Person | PcfraPerson;
}

export const PersonHeader: FunctionComponent<Props> = ({ person }) => {
  const property = useProperty(person.propertyId);

  const name = person?.fullName;
  const breadcrumbLinks = property ? [...getPropertyBreadcrumbs(property), { name }] : [];

  return (
    <PageHeader breadcrumbLinks={breadcrumbLinks}>
      <h1>{name}</h1>
      {property && <address>{property.address}</address>}
    </PageHeader>
  );
};
